module.exports = __webpack_public_path__ + "static/media/support-science.7ca39c0d.svg";